(function () {
  const ENDPOINT = '/apps/wb/wishlist';
  const TOGGLE_ENDPOINT = '/apps/wb/wishlist/toggle';
  const CACHE_KEY = 'wb_wishlist_v1';
  const CACHE_TTL_MS = 5 * 60 * 1000; // 5 min

  function readCache() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.t > CACHE_TTL_MS) return null;
      return parsed.items;
    } catch {
      return null;
    }
  }

  function writeCache(items) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items }));
    } catch {}
  }

  function clearCache() {
    try { sessionStorage.removeItem(CACHE_KEY); } catch {}
  }

  async function fetchWishlist() {
    const cached = readCache();
    if (cached) return cached;
    try {
      const res = await fetch(ENDPOINT, { credentials: 'same-origin' });
      if (!res.ok) return [];
      const json = await res.json();
      const items = json.items || [];
      writeCache(items);
      return items;
    } catch {
      return [];
    }
  }

  function applyHeartStates(items) {
    const ids = new Set(items.map((it) => String(it.product_id)));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.getAttribute('data-product-id');
      const active = ids.has(String(id));
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
    });
  }

  async function hydrate() {
    if (!document.querySelector('[data-wishlist-toggle]')) return;
    const items = await fetchWishlist();
    applyHeartStates(items);
  }

  function showFlash(message, isError) {
    var existing = document.querySelector('.wb-wishlist-flash');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'wb-wishlist-flash' + (isError ? ' wb-wishlist-flash--err' : '');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('wb-wishlist-flash--show'); }, 10);
    setTimeout(function () {
      el.classList.remove('wb-wishlist-flash--show');
      setTimeout(function () { el.remove(); }, 250);
    }, 3500);
  }

  async function onToggle(btn) {
    const productId = btn.getAttribute('data-product-id');
    if (!productId) return;

    // Storefront-session login state, rendered server-side by Liquid.
    // Empty string = guest. With Shopify's "new customer accounts" the user
    // can be logged in to account.westbluecollectibles.com but not have a
    // storefront session — which is what causes the wishlist 401s.
    const customerId = (btn.getAttribute('data-customer-id') || '').trim();
    if (!customerId) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/account/login?return_url=${next}`;
      return;
    }

    const wasActive = btn.classList.contains('is-active');

    // Optimistic toggle
    btn.classList.toggle('is-active');
    btn.setAttribute('aria-pressed', !wasActive ? 'true' : 'false');
    btn.disabled = true;

    try {
      const res = await fetch(TOGGLE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          product_id: productId,
          handle: btn.getAttribute('data-product-handle') || '',
          title: btn.getAttribute('data-product-title') || '',
          image: btn.getAttribute('data-product-image') || '',
          price: btn.getAttribute('data-product-price') || '',
        }),
      });

      if (res.status === 401) {
        // Storefront says we're logged in but Shopify's App Proxy doesn't see
        // the customer. Surface this instead of bouncing to login (which would
        // just dump the user on /account/orders and look like a broken click).
        btn.classList.toggle('is-active');
        btn.setAttribute('aria-pressed', wasActive ? 'true' : 'false');
        showFlash("Couldn't update favorites — please refresh and try again.", true);
        console.error('wishlist toggle 401 despite logged-in storefront customer', { customerId });
        return;
      }

      if (!res.ok) throw new Error('toggle failed');
      const json = await res.json();
      writeCache(json.items || []);
      showFlash(wasActive ? 'Removed from favorites' : 'Added to favorites', false);
    } catch (err) {
      // Revert on failure
      btn.classList.toggle('is-active');
      btn.setAttribute('aria-pressed', wasActive ? 'true' : 'false');
      console.error('wishlist toggle failed', err);
      showFlash("Couldn't update favorites.", true);
    } finally {
      btn.disabled = false;
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    onToggle(btn);
  });

  // Hydrate on initial load + after Shopify section re-renders
  document.addEventListener('DOMContentLoaded', hydrate);
  document.addEventListener('shopify:section:load', hydrate);

  // Expose for the wishlist page to reuse
  window.__wbWishlist = { fetch: fetchWishlist, clearCache };
})();
